<template>
    <layout>
        <div class="absolute top-0 left-0 z-0 w-full h-64 bg-light_yellow" style="z-index:-1;" v-if="configs.featured==true"></div>
        <div class="container z-10 px-4 mx-auto md:pt-4">  
            <div class="max-w-4xl mx-auto my-8 ">
                <SearchComponent />     
                <div class="flex flex-wrap justify-center w-full mt-6">
                    <ButtonComponent 
                        v-for="category in $page.props.categories"
                        :content="category.name" 
                        :icon="null"
                        :link="'/category/'+category.id+'/fruits'"
                        type="1"
                        @click="createFarm" 
                        />
                </div>
            </div>
            <div v-if="favorites!=null">
                <h2 v-if="favorites.length > 0" class=" my-9 text-enriqueto_green">Tus Favoritos</h2>
                <fruit-colletion v-if="favorites.length > 0" :list="favorites" :card="true" :cols="4" />  
            </div>
            <hr class="mt-8 border-light_gray"/>
            <h2 class=" my-9 text-enriqueto_green">Todo el mercado</h2>
            <FruitCollectionPaginated category="0" :list="fruits" :showActions="false" />
            <br>
            <div v-if="configs.blog==true">
                <h2 class=" my-9 text-enriqueto_green">Noticias</h2>
                <BlogSlider :items="blogs" /> 
            </div>
        </div>
    </layout>    
</template>

<script>
import FruitColletion from '../Components/Fruit/FruitColletion.vue'
import FruitCollectionPaginated from '../Components/Fruit/FruitCollectionPaginated.vue'
import Layout from '../Components/Shared/Layout.vue'
import { Link } from '@inertiajs/inertia-vue3'
import SearchComponent from '../Components/Shared/SearchComponent.vue'
import BlogSlider from '../Components/Blog/BlogSlider.vue'
import Map from '../Components/Map/Map.vue'
import ButtonComponent from '../Components/Shared/ButtonComponent.vue'

export default {
    components: {FruitCollectionPaginated,FruitColletion, Layout,Link,SearchComponent,BlogSlider,Map,ButtonComponent},
    props: ['categories','fruits','blogs','configs','favorites'],
    setup(props) {
        return {
            
        } 
    }
}
</script>

<style>

</style>
